import { render, staticRenderFns } from "./doorCard.vue?vue&type=template&id=aafe54e8&scoped=true&"
import script from "./doorCard.vue?vue&type=script&lang=js&"
export * from "./doorCard.vue?vue&type=script&lang=js&"
import style0 from "./doorCard.vue?vue&type=style&index=0&id=aafe54e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafe54e8",
  null
  
)

export default component.exports